import { post } from '../utility';

export const add = ({ stationId, tankNumber, salesDate, volume, reason, callback }) => {
	post({
		method: 'salesOverride.add',
		params: { stationId, tankNumber, salesDate, volume, reason },
		callback,
	});
};

export const search = ({ includeHidden, callback }) => {
	post({
		method: 'salesOverride.search',
		params: { includeHidden },
		callback,
	});
};

export const remove = ({ salesOverrideId, callback }) => {
	post({
		method: 'salesOverride.remove',
		params: { salesOverrideId },
		callback,
	});
};
